module.exports = __webpack_public_path__ + "static/benjamins-gothic-demi-bold-2503cc45a8eff90f1cb75380736b1299.woff";